import InputBlock from 'components/UI/inputBlock/InputBlock'
import { useDeviceType } from 'components/hooks/useDeviceType'
import classes from './TeamManagementPage.module.css'

function CommandSelector({ commands, commandList, commandValue, onSelect }) {
    const device = useDeviceType()

    return (
        <>
            {commands?.length >= 1 && commandList?.length > 0 && (
                device === "phone" ? (
                    <li>
                        <InputBlock
                            localRef={true}
                            readOnly={true}
                            indexStatus={true}
                            placeholder="Выберите команду"
                            onListStatus={true}
                            list={commandList}
                            value={commandValue}
                            setValue={onSelect}
                        >
                            <img src={require("assets/images/arrow.jpg")} alt="arrow" />
                        </InputBlock>
                    </li>
                ) : (
                    <li>
                        <InputBlock
                            placeholder="Выберите команду"
                            localRef={true}
                            readOnly={true}
                            indexStatus={true}
                            onListStatus={true}
                            list={commandList}
                            value={commandValue}
                            setValue={onSelect}
                        >
                            <img src={require("assets/images/arrow.jpg")} alt="arrow" />
                        </InputBlock>
                    </li>
                )
            )}
        </>
    )
}

export default CommandSelector

